<template>
  <b-overlay :show="languageBusy">
    <portlet title="يېڭىدىن رايون قوشۇش">
      <template v-slot:body>
        <language-form
          ref="language"
          @storing="onStoring"
          @stored="onStored"
        />
      </template>
      <template v-slot:foot>
        <b-button id="submit" @click="handleSubmit" variant="primary">
          ساقلاش
        </b-button>
        <b-button class="ml-2" variant="danger">
          بىكار قىلىش
        </b-button>
      </template>
    </portlet>
  </b-overlay>
</template>

<script>
  import Portlet from "@v@/partials/content/Portlet";
  import LanguageForm from "@v@/components/forms/LanguageForm";
  import BreadCrumbs from "@c@/breadcrumbs.service";
  import formBusyMixin from "@m@/common/formBusy.mixin";
  import { debugConsole } from "@c@/helpers/helpers";
  export default {
    name: "index",
    components: { Portlet, LanguageForm },
    mixins: [ formBusyMixin ],
    mounted() {
      BreadCrumbs.setBreadCrumb([]);
      BreadCrumbs.addBreadCrumb({title: 'تىل باشقۇرۇش', route: {name: 'language.home'}});
      BreadCrumbs.addBreadCrumb({title: 'يېڭىدىن تىل قوشۇش'});
      if ( this.$refs.hasOwnProperty('language') ){
        this.form = this.$refs['language'];
      }
    },
    data(){
      return {
        languageBusy: false,
        form: {}
      };
    },
    methods: {
      handleSubmit(){
        this.form.onSubmit();
      },
      onStoring(){
        this.showBusy('languageBusy');
        debugConsole({prefix: 'language', message: `onStored`});
      },
      onStored(state){
        this.hideBusy('languageBusy');
        debugConsole({prefix: 'language', message: `onStored: ${state}`});
        this.$router.replace({name: 'language.home'});
      }
    }
  }
</script>

<style scoped>

</style>
